import intl from 'react-intl-universal';

import BigNumber, { isNil, parse2Number } from '@/utils/number';

// 整数 一位小数 两位小数 空字符
const NUM_REG = /^(\d*)(\.\d{1,2})?$/;
const MAX_VAL = 99999.99;

// 校验输入 返回是否有错误
export const validateInputValue: (inputStr: string) => string = (inputStr) => {
  let errText = '';
  try {
    // 输入格式匹配
    if (NUM_REG.test(inputStr)) {
      const numberVal = parse2Number(inputStr);
      if (numberVal > MAX_VAL) {
        errText = intl.get('reservation_cmp_number_input_error_limit');
      } else {
        errText = '';
      }
    } else {
      errText = intl.get('reservation_cmp_number_input_error_invalid');
    }
  } catch (e) {
    //
  }
  return errText;
};

// 整数
export const createIntegerRange = (min?: number, max?: number) => {
  const minValue = isNil(min) ? 0 : min;
  const maxValue = isNil(max) ? Math.floor(MAX_VAL) : max;

  return (val) => {
    if (isNil(val)) return; // 空值
    if (NUM_REG.test(val)) {
      // 格式正确
      const input = new BigNumber(val);
      if (input.isGreaterThan(MAX_VAL)) {
        // 超过全局最大值
        throw new Error(intl.get('reservation_cmp_number_input_error_limit'));
      }
      if (input.isLessThan(minValue) || input.isGreaterThan(maxValue) || !input.isInteger()) {
        // 小于最小值 超过最大值 非整数
        throw new Error(
          intl.get('cmp_input_money_integer_invalid', { min: minValue, max: maxValue }),
        );
      }
    } else {
      // 格式错误
      throw new Error(intl.get('reservation_cmp_number_input_error_invalid'));
    }
  };
};

// 小数
export const createDecimalRange = (min?: number, max?: number) => {
  const minValue = isNil(min) ? 0 : min;
  const maxValue = isNil(max) ? max : MAX_VAL;

  return (val) => {
    if (isNil(val)) return; // 空值
    if (NUM_REG.test(val)) {
      // 格式正确
      const input = new BigNumber(val);
      if (input.isGreaterThan(MAX_VAL)) {
        // 超过全局最大值
        throw new Error(intl.get('reservation_cmp_number_input_error_limit'));
      }
      if (input.isLessThan(minValue) || input.isGreaterThan(maxValue)) {
        // 小于最小值 超过最大值
        throw new Error(
          intl.get('cmp_input_money_decimal_invalid', {
            min: minValue,
            max: maxValue,
            decimal: 2,
          }),
        );
      }
    } else {
      // 格式错误
      throw new Error(intl.get('reservation_cmp_number_input_error_invalid'));
    }
  };
};

// 基础小数验证
export const baseDecimalValidator = createDecimalRange(0, MAX_VAL);

// 数值格式
export const valueFormat = (val) => {
  if (isNil(val)) return val;
  const input = new BigNumber(val);
  if (input.isNaN()) return val;
  return input.toFixed(2, BigNumber.ROUND_DOWN);
};
